module.exports = __webpack_public_path__ + "media/images/default/homepage/experience/experience02-59e7f7307d6c353d019fe1ed8977d6f0.svg";